import type { ComponentType } from 'react'
import {
  BellRing,
  Bot,
  Boxes,
  CalendarClock,
  CircuitBoard,
  Cpu,
  Database,
  Factory,
  Gauge,
  MapPin,
  Shield,
  Waypoints,
  Workflow
} from 'lucide-react'
import { PLANT_HREF, type PlantTab } from '@atbash-labs/plantview-links'

export interface PlantTabSpec {
  value: PlantTab
  label: string
  icon: ComponentType<{ size?: number | string; className?: string }>
  path: string
}

export interface PlantTabFlags {
  dcs: boolean
  network: boolean
  safety: boolean
}

const PLANT_TABS: PlantTabSpec[] = [
  { value: 'equipment', label: 'Factory', icon: Factory, path: PLANT_HREF.equipmentIndex },
  { value: 'processes', label: 'Processes', icon: Workflow, path: PLANT_HREF.processesIndex },
  { value: 'areas', label: 'Areas', icon: MapPin, path: PLANT_HREF.areasIndex },
  { value: 'compute', label: 'Compute', icon: Cpu, path: PLANT_HREF.computeIndex },
  { value: 'queries', label: 'Queries', icon: Database, path: PLANT_HREF.queriesIndex },
  { value: 'plc', label: 'PLC', icon: CircuitBoard, path: PLANT_HREF.plcIndex },
  { value: 'dcs', label: 'DCS', icon: Gauge, path: PLANT_HREF.dcsIndex },
  { value: 'network', label: 'Network', icon: Waypoints, path: PLANT_HREF.networkIndex },
  { value: 'robotics', label: 'Robotics', icon: Bot, path: PLANT_HREF.roboticsIndex },
  {
    value: 'schedules',
    label: 'Schedules',
    icon: CalendarClock,
    path: PLANT_HREF.schedulesIndex
  },
  { value: 'alarms', label: 'Alarms', icon: BellRing, path: PLANT_HREF.alarmsIndex },
  { value: 'safety', label: 'Safety', icon: Shield, path: PLANT_HREF.safetyIndex }
]
const MODEL_TAB: PlantTabSpec = {
  value: 'model',
  label: 'Model',
  icon: Boxes,
  path: PLANT_HREF.modelIndex
}

export function plantTabsForDebug(debugMode: boolean, flags: PlantTabFlags): PlantTabSpec[] {
  const tabs = PLANT_TABS.filter((tab) => {
    if (tab.value === 'dcs') return flags.dcs
    if (tab.value === 'network') return flags.network
    if (tab.value === 'safety') return flags.safety
    return true
  })
  return debugMode ? [...tabs, MODEL_TAB] : tabs
}
